
// 返回在vue模板中的调用接口
export default {
  baseUrl: "http://localhost:46666",
  }



// WEBPACK FOOTER //
// ./src/config.js